import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { subYears } from 'date-fns'

import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'
import MissingDataPageIcon from '../../../../assets/img/missing-data-icon.webp'
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Icon from '../../../../components/ui/Icon/Icon'

import validateMissingData from '../../../../services/validation/UpdateMissingData'
// import * as ProfileApiService from '../../../../services/api/requests/Profile'
// import * as RegisterApiService from '../../../../services/api/requests/Register'

import MissingDataProfilePageForm from '../MissingDataProfilePageForm/MissingDataProfilePageForm'

import { MAIN } from '../../../../services/data/profilePages.json'

const MainPage = styled.div`
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  display: flex;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  ${({ hasExitButton }) => hasExitButton && 'margin-right: 60px;'}
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Description = styled.p`
  font-size: 0.8rem;
  line-height: 1.3125rem;
  letter-spacing: var(--letter-spacing-narrower);
  text-align: center;
  margin-top: 0;
`

const Content = styled.div`
  flex: 1 1 auto;
  position: relative;
  padding: 2rem;
  overflow: auto;

  display: flex;
  flex-direction: column;
`

const UpdateProfileIcon = styled.img.attrs({ src: MissingDataPageIcon })`
  margin: 1.5rem;
  width: 10rem;
  align-self: center;
`

const MissingDataProfilePage = ({
  setProfileModalPage,
  primaryInfo,
  accessToken,
  setPrimaryInfo,
  doUpdateMissingData,
  displayProfileModal,
}) => {
  // const [errorMessage, setErrorMessage] = React.useState('')
  const [yesterday] = React.useState(subYears(new Date(), 13))

  const callback = () => {
    // setProfileModalPage(MAIN)
    displayProfileModal(false)
  }

  const { birthdate, gender } = primaryInfo || {}

  return (
    <MainPage>
      <Header>
        <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
          <Icon name="slide-left" />
        </ReturnIcon>
        <Title>Update My Profile</Title>
      </Header>
      <Content>
        <UpdateProfileIcon />
        <Description>
          Complete your details to participate in promotional offers and loyalty
          benefits such as double points on your birth month.
        </Description>
        <AccessibleForm
          initialValues={{
            birthdate,
            gender,
            yesterday,
          }}
          validate={validateMissingData}
          onSubmit={doUpdateMissingData({
            accessToken,
            setPrimaryInfo,
            primaryInfo,
            callback,
          })}
          component={MissingDataProfilePageForm}
          action="/a/profile/update"
        />
      </Content>
    </MainPage>
  )
}

MissingDataProfilePage.defaultProps = {
  primaryInfo: {},
}

MissingDataProfilePage.propTypes = {
  primaryInfo: PropTypes.object,
}

export default MissingDataProfilePage
